// eslint-disable-next-line import/prefer-default-export
export const navigation = {
  redirectToUrl (url, newTab = false) {
    const target = decodeURIComponent(url);
    if (newTab) {
      window.open(target, '_blank');
      return;
    }
    window.location.href = target;
  }
};
